import React from 'react';

import Thumb from '../img/blogs/react.jpg';

const ReactHooks = {
    id: 12, permalink: "react-hooks", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 06, 2020", categories: "ReactJS, Hooks", title: "React- Hooks", shortDesc: "React Hooks let us to use state and other React features without writing a class. This are new addition in React 16.8.", fullDesc: <>
        <h2>What are React Hooks?</h2>
        <p><strong>React Hooks</strong> let us use state and other <strong>React</strong> features without writing a <strong>class</strong>. This is new addition in <strong>React 16.8</strong>.</p>

        <p><em><strong>React</strong> includes a stable implementation of <strong>React Hooks</strong> for</em>:</p>
        <ul>
            <li>React DOM</li>
            <li>React Native</li>
            <li>React DOM Server</li>
            <li>React Test Renderer</li>
            <li>React Shallow Renderer</li>
        </ul>

        <p>To enable Hooks, all React packages need to be 16.8.0 or higher.</p>


        <h2>What are Closures?</h2>
        <p><strong>Closures</strong> are inner <strong>functions</strong> that have access to the outer <strong>function's variables and parameters</strong>.</p>

        <pre className="code">
            const useState = initVal => &#123; <br />
                &nbsp; let val = initVal; <br />
                &nbsp; const state = () => val; <br />
                &nbsp; const setState = newVal => val = newVal; <br />
                &nbsp; return [state, setState]; <br />
            &#125; <br />
            const [count, setCount] = useState(0); <br />
            console.log(count()); <br />
            setCount(1); <br />
            console.log(count());
        </pre>
        <p>Here, we are creating a primitive clone of <strong>React’s</strong> <code>useState</code> Hook. In our <strong>function</strong>, there are 2 inner <strong>functions</strong>, <code>state</code>, and <code>setState</code>. The <code>state</code> returns a local variable <code>val</code> as described above and the <code>setState</code> sets the local <strong>variable</strong> to the parameter given in it (i.e. <code>newVal</code>).</p>


        <h2>React Hooks Usage in Function Components</h2>
        <p>Let's apply the <code>useState</code> clone in a familiar-looking setting. We'll create a <strong>Counter</strong> component!</p>

        <pre className="code">
            const useState = initVal => &#123; <br />
                &nbsp; let val = initVal; <br />
                &nbsp; const state = () => val; <br />
                &nbsp; const setState = newVal => val = newVal; <br />
                &nbsp; return [state, setState]; <br />
            &#125; <br /><br />

            const Counter = () => &#123; <br />
                &nbsp; const [count, setCount] = useState(0); <br />
                &nbsp; return &#123; <br />
                    &nbsp;   click: () => setCount(count() + 1), <br />
                    &nbsp;   render: () => console.log("render:", &#123; count: count() &#125;) <br />
                &nbsp; &#125;; <br />
            &#125;; <br />
            const C = Counter(); <br />
            C.render(); <br />
            C.click(); <br />
            C.render();
        </pre>
        <p><strong>Expected output:</strong> <code class="output">render: &#123; count: 0 &#125;</code> and <code class="output">render: &#123; count: 1 &#125;</code></p>


        <h2>Rules of Hooks</h2>
        <p><em>When we use <strong>Hooks</strong> we have to follow two rules</em>:</p>
        <ul>
            <li><strong>Only call Hooks at the top level</strong>. We Shouldn't call <strong>Hooks inside loops, conditions, or nested functions</strong>.</li>
            <li><strong>Only call Hooks from React function components</strong>. We Shouldn't  call <strong>Hooks</strong> from regular <strong>JavaScript functions</strong>.</li>
        </ul>

        <h3>Only Call Hooks at the Top Level</h3>
        <p>We Shouldn't call <strong>Hooks inside loops, conditions, or nested functions</strong>. Instead, always have to use <strong>Hooks</strong> at the top level of our <strong>React function</strong>. By following this rule, we can sure that <strong>Hooks</strong> is called in the same order every time a component is rendered.</p>

        <h3>Only Call Hooks from React Functions</h3>
        <p><em>We Shouldn't call <strong>Hooks</strong> from regular <strong>JavaScript functions</strong>. Instead, we can</em>:</p>
        <ul>
            <li>Call Hooks from React function components.</li>
            <li>Call Hooks from custom Hooks.</li>
        </ul>

        <p>By following this rule, we can ensure that all stateful logic in a component is clearly visible from its source code.</p>


        <h2>uesMemo()</h2>
        <p><code>uesMemo()</code> is another method from the <strong>Hook API</strong> that helps to optimize performance. If dependencies remain the same, it <strong>memoizes</strong> and returns the same value for the expensive calculations.</p>

        <pre className="code">
            import React, &#123; useState, useMemo &#125; from "react"; <br /><br />

            const App = () =&gt; &#123; <br />
                &nbsp; const [counter, setCounter] = useState(0); <br />
                &nbsp; const changeCounter = counterVal =&gt; "Counter: " + counterVal; <br />
                &nbsp; const memoCounter = useMemo(() => changeCounter(counter), [counter]); <br />
                &nbsp; return ( <br />
                    &nbsp;   &lt;div className="App"&gt; <br />
                        &nbsp;     &lt;div&gt;Normal &#123;changeCounter(counter)&#125;&lt;&#47;div&gt; <br />
                        &nbsp;     &lt;div&gt;Memo &#123;memoCounter&#125;&lt;&#47;div&gt; <br />
                        &nbsp;     &lt;button onClick=&#123;() =&gt; setCounter(prevState =&gt; ++prevState)&#125;&gt;Increment&lt;&#47;button&gt; <br />
                    &nbsp;   &lt;&#47;div&gt; <br />
                &nbsp; ); <br />
            &#125;; <br />
            export default App;
        </pre>


        <h2>When to Use uesMemo()</h2>
        <p>According to <strong>React documentation</strong>, you should use <code>useMemo()</code> for expensive calculations.</p>

        <p><em>Here are some situations where you can use it</em>:</p>
        <ul>
            <li><strong>Filtering Large Arrays</strong></li>
            <li><strong>Recursive functions, like the Fibonacci series, factorial, etc.</strong></li>
        </ul>

        <p><strong>Note:</strong> Avoid unnecessary Child component rendering.</p>


        <h2>How re-render works in react</h2>
        <p>In <strong>React</strong>, when a parent component re-renders, then its child components are also re-render (if no optimization applied for child components).</p>

        <p><em>A component re-render can be triggered in several ways, some of which are</em>:</p>
        <ul>
            <li>Change in the <strong>component’s state</strong>.</li>
            <li>Change in the <strong>component’s props</strong>.</li>
        </ul>

        <pre className="code">
            import React, &#123; useState &#125; from "react"; <br /><br />

            const App = () =&gt; &#123; <br />
                &nbsp; const [counter, setCounter] = useState(0); <br />
                &nbsp; const changeCounter = counterVal =&gt; "Counter: " + counterVal; <br />
                &nbsp; return ( <br />
                    &nbsp;   &lt;div className="App"&gt; <br />
                        &nbsp;     &lt;div&gt;&#123;changeCounter(counter)&#125;&lt;&#47;div&gt; <br />
                        &nbsp;     &lt;button onClick=&#123;() =&gt; setCounter(prevState =&gt; ++prevState)&#125;&gt;Increment&lt;&#47;button&gt; <br />
                    &nbsp;   &lt;&#47;div&gt; <br />
                &nbsp; ); <br />
            &#125;; <br />
            export default App;
        </pre>


        <h2>useCallback()</h2>
        <p><code>useCallback()</code> takes a <strong>function</strong> and a dependency array that can contain <strong>variables or functions</strong>. If the <strong>variable or function's</strong> identity in the <strong>dependency array changes</strong>, we get a new <strong>function</strong>, otherwise we get a <strong>cached function</strong>.</p>

        <pre className="code">
            import React, &#123; useState, useCallback &#125; from "react"; <br /><br />

            const App = () =&gt; &#123; <br />
                &nbsp; const [counter, setCounter] = useState(0); <br />
                &nbsp; const changeCounter = counterVal =&gt; "Counter: " + counterVal; <br />
                &nbsp; const clickHandle = useCallback(() => &#123; <br />
                    &nbsp;   setCounter(prevState => ++prevState); <br />
                &nbsp; &#125;, []); <br />
                &nbsp; return ( <br />
                    &nbsp;   &lt;div className="App"&gt; <br />
                        &nbsp;     &lt;div&gt;&#123;changeCounter(counter)&#125;&lt;&#47;div&gt; <br />
                        &nbsp;     &lt;button onClick=&#123;clickHandle&#125;&gt;Increment&lt;&#47;button&gt; <br />
                    &nbsp;   &lt;&#47;div&gt; <br />
                &nbsp; ); <br />
            &#125;; <br />
            export default App;
        </pre>


        <h2>What are Custom hooks?</h2>
        <p><strong>Custom Hooks</strong> are normal <strong>JavaScript functions</strong> that can use other <strong>Hooks</strong> inside of it and contain a common stateful logic that can be reused within multiple components. These <strong>functions</strong> are prefixed with the word use.</p>

        <p>Suppose we have 2 <strong>functions (components)</strong> that implement some common logic. We can create a third <strong>function</strong> with this common logic and implement it in the other two <strong>functions</strong>. After all, Hooks are just <strong>functions</strong>.</p>

        <p>In a word, <strong>Custom Hooks</strong> mean fewer keystrokes and less repetitive <code>code</code>.</p>


        <h2>Let's create useDocumentTitle() Hook</h2>
        <p>Suppose, we need to create a <strong>component</strong> that increases the count with each click and updates the <strong>page title</strong> with the count value using the <strong>Hook</strong>.</p>

        <pre className="code">
            import React, &#123; useState, useEffect &#125; from "react"; <br /><br />

            const useDocumentTitle = title =&gt; &#123; <br />
                &nbsp; useEffect(() =&gt; &#123; <br />
                    &nbsp;   document.title = title; <br />
                &nbsp; &#125;, [title]); <br />
            &#125;; <br /><br />

            const App = () =&gt; &#123; <br />
            &nbsp; const [count, setCount] = useState(0); <br />
            &nbsp; const increment = () =&gt; setCount(count + 1); <br />
            &nbsp; const title = "You clicked " + count + " times."; <br />
            &nbsp; useDocumentTitle(title); <br />
            &nbsp; return ( <br />
                &nbsp;   &lt;div className="App"&gt; <br />
                    &nbsp;     &lt;h2&gt;Counter: &#123;count&#125;&lt;&#47;h2&gt; <br />
                    &nbsp;     &lt;button&gt; onClick=&#123;increment&#125;&gt;Increment&lt;&#47;button&gt; <br />
                &nbsp;   &lt;&#47;div&gt; <br />
            &nbsp; ); <br />
            &#125;; <br />
            export default App;
        </pre>

        <h4>This is easy, but not useful? Where can it be useful?</h4>
        <p>To show unread <strong>messages or notifications</strong> on <strong>social media</strong>. We can use the <code>useDocumentTitle()</code> <strong>Hook</strong> where we receive the <strong>messages or notifications</strong> and then we can call this <strong>Hook</strong> with a count of unread <strong>messages or notifications and title</strong>.</p>
    </>
};
export default ReactHooks;